import React, { Component } from 'react';
import { Grid, Label, Divider, Button } from 'semantic-ui-react'
import * as moment from 'moment';
import axios from 'axios'
import { base, serverIp } from '../../../../config/constants';
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import * as Utils from '../../../../Utilities/Utils'
import Status from '../../../../config/OrderStatusConstants.js'
import { Form } from 'semantic-ui-react'
import * as UiConsts from '../../../../config/UiConstants';

class ReturnStock extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderType: '',
            orderTypeChoices: [],
            loading: false,
            couponCode: ''
        }
    }

    componentDidMount() {
        //SHIRT COLORS
        console.log("rtx10: this.props.order.key"+JSON.stringify(this.props.order, null, 3));
       // console.log("rtx1: this.props.order.key"+this.props.order.key);
    }

    /**
* HANDLE DROPDOWN FOR ORDER ONE
*/
    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    setReturnedToStock = (stockLevel) => {
        console.log("this.props.order.key:" + this.props.order.key);
        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
        let orderUpdates = {
            returnedToStock: true,
            returnedToStockOn: now,
            returnedToStockBy: this.props.user.email,
            stockLevel: stockLevel,
            coupon: this.state.couponCode
        }

        
        base.update('orders/' + this.props.mainOrder.key + '/singleOrders/' + this.props.order.key, {
            // data: {uid: userUid},
            data: orderUpdates,
            then: (err) => {
                if (!err) {
                    console.log("updated setReturnedToStock order no error");

                  
                }
            }

        });
    }

    addBackToStock = () => {
        console.log("cpx1 ======addBackToStock");

        this.setState({ loading: true })

        axios.post(serverIp + 'stock/addBackToStock', {
            apiKey: "addBackToStock",
            singleOrderKey: this.props.order.key,
            adminEmail: this.props.user.email,
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log(response.data);

                if (response.data.result) {
                    console.log("true.. setting coupon");
                    this.setReturnedToStock(response.data.stockLevel);
                    alert("SUCCESS! added back to stock SET");
                } else {
                    console.log("FAILED");
                    alert("FAILED!!! TO add back:" + response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });
    }


    render() {

        const addBackButton = this.props.mainOrder.itemType === 'phoneCase_wooden'
            ? <Button onClick={this.addBackToStock}>ADD BACK TO STOCK</Button>
            : ''

            const addedBackToStock = this.props.order.returnedToStock
            ? <h4> ALREADY RETURNED TO STOCK  by {this.props.order.returnedToStockBy}</h4>
            : ""

        const showUI = <div>
                <Divider horizontal>{'ADD BACK TO STOCK'}</Divider>
                {addedBackToStock}
                <Form>
                    {addBackButton}
                </Form>
            </div>
       
      

        return (

            this.state.loading ? <UiConsts.LoadingComponent /> :

                <div>
                    {showUI}
                    <br/>
                </div>
        )
    }
}

export default ReturnStock;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/AddBackToStock/ReturnStock.js